import type SubstrateSearchRequest from "../../data/schema/SubstrateSearchRequest";
import type { SearchResultFlagType, SearchResultFolderId, SearchResultItemId, SearchResultRecipient, } from "../../data/schema/SubstrateSearchResponse";
import type ExecuteSearchSortOrder from "owa-service/lib/contract/ExecuteSearchSortOrder";
import type FlagType from "owa-service/lib/contract/FlagType";
import type { FolderId } from "owa-graph-schema";
import type ItemId from "owa-service/lib/contract/ItemId";
import type SingleRecipientType from "owa-service/lib/contract/SingleRecipientType";

export function convertToNormalizedSubject(subject: string): string {
    const MAX_COLON_INDEX = 6;
    
    if (!subject) {
        return subject;
    }
    
    const colonIndex = subject.indexOf(":");
    
    /**
     * We don't look at what the prefix text is, just that a colon is in the subject
     * and it's not "too far" from the start of the string.
     */
    if (colonIndex > 0 && colonIndex < MAX_COLON_INDEX && colonIndex + 1 < subject.length) {
        return subject.substring(colonIndex + 1).trim();
    }
    
    return subject;
}

export function convertToItemId(id: SearchResultItemId): ItemId {
    if (id) {
        return {
            Id: id.Id,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (42,13): Type 'null' is not assignable to type 'string | undefined'.
            // @ts-expect-error
            ChangeKey: null,
        };
    }
    
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (49,5): Type 'null' is not assignable to type 'ItemId'.
    // @ts-expect-error
    return null;
}

export function convertUtcDateTimeToRequestTimeZone(utcDateTimeString: string, request: SubstrateSearchRequest): string {
    let convertedDateTimeString = null;
    
    if (request?.TimeZone && utcDateTimeString) {
        const utcDateTime = new Date(utcDateTimeString);
        convertedDateTimeString = utcDateTime.toISOString();
    }
    
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (66,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    return convertedDateTimeString;
}

export function convertToFlagType(flag: SearchResultFlagType): FlagType {
    if (!flag) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (74,9): Type 'null' is not assignable to type 'FlagType'.
        // @ts-expect-error
        return null;
    }
    
    return {
        FlagStatus: flag.FlagStatus,
        CompleteDate: flag.CompleteDate,
        DueDate: flag.DueDate,
        StartDate: flag.StartDate,
    };
}

export function convertRecipientToSingleRecipientType(recipient: SearchResultRecipient): SingleRecipientType {
    if (recipient?.EmailAddress) {
        return {
            Mailbox: {
                EmailAddress: recipient.EmailAddress.Address,
                Name: recipient.EmailAddress.Name,
                RoutingType: "SMTP",
            },
        };
    }
    
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (101,5): Type 'null' is not assignable to type 'SingleRecipientType'.
    // @ts-expect-error
    return null;
}

export function convertToFolderId(id: SearchResultFolderId): FolderId {
    if (id) {
        return {
            __typename: "FolderId",
            ChangeKey: id.ChangeKey,
            Id: id.Id,
        };
    }
    
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (115,5): Type 'null' is not assignable to type 'FolderId'.
    // @ts-expect-error
    return null;
}

export function convertSearchSortOrder(source: string): ExecuteSearchSortOrder {
    switch (source) {
        case "DateTime":
            return "DateTime";
        case "Hybrid":
            return "Hybrid";
        case "Relevance":
            return "Relevance";
        default:
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (130,13): Type 'null' is not assignable to type 'ExecuteSearchSortOrder'.
            // @ts-expect-error
            return null;
    }
}

export function convertToItemIds(ids: SearchResultItemId[]): ItemId[] {
    if (ids === null || ids.length === 0) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (139,9): Type 'null' is not assignable to type 'ItemId[]'.
        // @ts-expect-error
        return null;
    }
    
    const convertedIds: ItemId[] = [];
    
    for (let i = 0; i < ids.length; i++) {
        convertedIds[i] = convertToItemId(ids[i]);
    }
    
    return convertedIds;
}
